import {EmptySearchVariant, StyledEmptyState} from '@/components/commons/empty-state/style'
import {FC, HTMLAttributes, ReactNode} from 'react'
import {AlertCircleIcon} from '@components/ui/icon/Icon.tsx'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

export interface EmptyStateProps extends HTMLAttributes<HTMLDivElement> {
    title: string
    subtitle?: string
    children?: ReactNode
    variant?: EmptySearchVariant
}
export const EmptyState: FC<EmptyStateProps> = ({children, title, subtitle, variant = 'primary', ...props}) => {
    return (
        <StyledEmptyState $variant={variant} {...props}>
            <AlertCircleIcon size={16} />
            <Flexbox direction="column" align="center" gap={1}>
                {!!title && <h3>{title}</h3>}
                {!!subtitle && <h4>{subtitle}</h4>}
            </Flexbox>
            {children}
        </StyledEmptyState>
    )
}

EmptyState.displayName = 'EmptyState'
